"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimationCover = exports.AnimationContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AnimationContainer = _styledComponents["default"].div.withConfig({
  displayName: "AnimationContainerstyle__AnimationContainer",
  componentId: "sc-p6sz21-0"
})(function () {
  return (0, _styledComponents.css)(["position:relative;height:100%;"]);
});

exports.AnimationContainer = AnimationContainer;

var AnimationCover = _styledComponents["default"].div.withConfig({
  displayName: "AnimationContainerstyle__AnimationCover",
  componentId: "sc-p6sz21-1"
})(function () {
  return (0, _styledComponents.css)(["position:absolute;width:calc(100% + 6px);height:calc(100% + 6px);background-color:red;z-index:100;top:-3px;left:-3px;"]);
});

exports.AnimationCover = AnimationCover;
//# sourceMappingURL=AnimationContainer.style.js.map